// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"644":"3351934c","732":"5c5df8f9"}[chunkId] + ".chunk.js";
};